/**
 * UpcomingSection - "Here is what coming up for you!" section
 * Design: Screen 2 from home-screen-revamp
 *
 * Features:
 * - Section header
 * - Horizontal scroll of UpcomingChallengeCard(s)
 */

import { HomeChallengeCard } from "@/api/home";
import { UpcomingChallengeCard } from "./UpcomingChallengeCard";

interface UpcomingSectionProps {
  challenges: HomeChallengeCard[];
  onChallengeClick: (challengeId: string) => void;
}

export function UpcomingSection({
  challenges,
  onChallengeClick,
}: UpcomingSectionProps) {
  if (challenges.length === 0) return null;

  return (
    <div className="pt-5 pb-4">
      {/* Section Header */}
      <h2 className="px-6 text-lg font-semibold text-white leading-[119.16%] font-dm-sans mb-4">
        Here is what coming
        <br />
        up for you !
      </h2>

      {/* Challenge Cards - Horizontal Scroll */}
      <div className="overflow-x-auto px-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div className="flex items-stretch gap-4">
          {challenges.map((challenge) => (
            <UpcomingChallengeCard
              key={challenge.id}
              id={challenge.id}
              name={challenge.name}
              type={challenge.type}
              startDate={challenge.startDate}
              onClick={() => onChallengeClick(challenge.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
